export enum StatusSprawy {
  Nowa = 1,
  Przydzielono,
  WTrakcieWeryfikacji,
  OczekujeNaRozpatrzenie,
  WTrakcieRozpatrywania,
  OczekujeNaWydanieDecyzji,
  WydanoDecyzje,
  DoreczonoDecyzje,
  UprawomocnionoDecyzje,
  WygenerowanoSzablonPostanowienia,
  OczekujeNaPodpisPostanowienia,
  WydanoPostanowienie,
  OczekujeNaPotwierdzenieOtrzymaniaPostanowienia,
  DoreczonoPostanowienie,
  DoUmorzenia,
  OczekujeNaPodpisDecyzjiOUmorzeniuPostepowania,
  WydanoDecyzjeOUmorzeniuPostepowania,
  OczekujeNaPotwierdzenieOtrzymaniaDecyzjiOUmorzeniuPostepowania,
  DoreczonoDecyzjeOUmorzeniuPostepowania,
  UprawomocnionoDecyzjeOUmorzeniuPostepowania,
  PrzydzielonoDoSprawyZUrzeduPracownika,
  ZawiadomienieOWszczeciu,
  WTrakcieWeryfikacjiPoZawiadomieniu,
  WszczetoPostepowanieStwierdzonoBrakiFormalne,
  SprawaZamknietaWycofanoPodanie,
  WplyneloOdwolanie,
  WPrzygotowaniuDoDrugiejInstancji,
  PrzekazanoDoDrugiejInstancji,
  RozpatrywanieOdwolania,
  OczekujeNaWydanieDecyzjiOdwolanie,
  WydanoDecyzjeOdwolanie,
  DecyzjaDoreczonaOdwolanie,
  DecyzjaPrawomocnaOdwolanie,
  WPrzygotowaniuDecyzjiZmieniajacej,
  OczekujeNaWydanieDecyzjiZmieniajacej,
  WydanoDecyzjeZmieniajaca,
  DoreczonoDecyzjeZmieniajaca,
  UprawomocnionoDecyzjeZmieniajaca,
  Zarchiwizowano,
  WplynalWniosekOPonowneRozpatrzenie,
  DecyzjaOPonowneRozpatrzenieWPrzygotowaniu,
  OczekujeNaWydanieDecyzjiOPonowneRozpatrzenie,
  WydanoDecyzjeOPonowneRozpatrzenie,
  DecyzjaOPonowneRozpatrzenieDoreczona,
  DecyzjaOPonowneRozpatrzeniePrawomocna,
  WygenerowanoSzablonDecyzjiZmieniajacej,
  SprawaZostawionaBezRozpoznania,
}
